import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useSeo } from "@/lib/seo";

export default function NotFoundPage() {
  useSeo({
    title: "Page not found | LUX",
    robots: "noindex,follow",
  });
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center sm:py-32" data-testid="not-found-page">
      <Compass className="mx-auto h-8 w-8 text-lux-silver" aria-hidden="true" />
      <p className="lux-label mt-6">404</p>
      <h1 className="mt-4 font-serif text-5xl sm:text-6xl">We can't find that page.</h1>
      <p className="mt-5 text-lux-muted">
        The link may be out of date or the profile may have been removed. Try one of our cities or use the help page.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link to="/london" className="lux-btn lux-btn-primary" data-testid="not-found-browse-link">Browse London</Link>
        <Link to="/birmingham" className="lux-btn lux-btn-secondary" data-testid="not-found-birmingham-link">Birmingham</Link>
        <Link to="/manchester" className="lux-btn lux-btn-secondary" data-testid="not-found-manchester-link">Manchester</Link>
        <Link to="/help" className="lux-btn lux-btn-ghost" data-testid="not-found-help-link">Help &amp; FAQ</Link>
      </div>
    </div>
  );
}
